// src/redux/Admin/companyViewSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  companyName: '',
};

const companyViewSlice = createSlice({
  name: 'companyView',
  initialState,
  reducers: {
    setCompanyName(state, action) {
      state.companyName = action.payload;
    },
    resetCompanyName(state) {
      state.companyName = '';
    },
  },
});

export const { setCompanyName, resetCompanyName } = companyViewSlice.actions;
export default companyViewSlice.reducer;
